var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.item.style == 1)?_c('div',{staticClass:"telBtn1",style:({margin: ((_vm.item.paddTop) + "px auto")})},[_vm._v(" "+_vm._s(_vm.item.text)+" ")]):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }